import { Collapse } from "bootstrap";
const Checkout = () => {
    return {

        init: function ($selector) {

            if (!$selector) {
                $selector = $(document);
            } else if (!($selector instanceof $)) {
                $selector = $($selector);
            }
            $selector.off('keyup', '.orderpos textarea');
            $selector.on('keyup', '.orderpos textarea', function (e) {
                var $field = $(this),
                    $row = $(e.target).parents('.row.comment'),
                    $handle = $row.find('a'),
                    $collapsible = $row.find('.collapse');

                if ($field.val().length === 0) {
                    $handle.attr('data-bs-toggle', 'collapse');
                    $handle.attr('href', '#' + $collapsible.attr('id'));
                    setTimeout(function () {
                        const rows = $row.find('.collapse').get();
                        [...rows].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.hide());
                    }, 3000);
                } else {
                    $handle.removeAttr('data-bs-toggle');
                    $handle.removeAttr('href');
                }
            });

            $selector.off('click', '.card-header.address *, input.new');
            $selector.on('click', '.card-header.address *, input.new', function (e) {
                e.stopPropagation();
                var $elTarget = $(e.target),
                    $el = $elTarget.closest('.card-header.address'),
                    $inputFields = $('.address-new input, .address-new select');

                $('.address .hidden.fields').children().attr('disabled', 'disabled');
                const addresses = $('#address-accordion .panel-collapse.in').get();
                [...addresses].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.hide());

                // Abweichende Lieferadresse eingeben
                if ($elTarget.is('input.new')) {
                    $inputFields.removeAttr('disabled');
                } else {
                    // Bereits bestehende Adresse verwenden
                    var accordionBodyHref = $el.find('a[data-bs-parent="#address-accordion"]').data('setu-href').split('#'),
                        $hiddenFields = $el.find('a[data-bs-parent="#address-accordion"]').find('input:hidden'),
                        $accordionBody = $('#' + accordionBodyHref[1]).get();

                    $hiddenFields.removeAttr('disabled');
                    [...$accordionBody].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.show());
                    $inputFields.attr('disabled', 'disabled');
                }
                $el.find('input[type="radio"]').prop('checked', true);
            });

            $selector.off('click', '.delete-address');
            $selector.on('click', '.delete-address', function (e) {
                e.preventDefault();
                $(e.target).parents('.card').first().remove();
            });

            $selector.off('click', '.card-header.payment *');
            $selector.on('click', '.card-header.payment *', function (e) {
                const payment = $('#payment-accordion .panel-collapse.in').get();
                [...payment].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.hide());
                e.stopPropagation();

                var $el = $(e.target),
                    accordionBodyHref = $el.is('a') ? $el.data('setu-href').split('#') : $el.parents('a[data-bs-parent="#payment-accordion"]').data('setuHref').split('#'),
                    $accordionBody = $('#' + accordionBodyHref[1]).get(),
                    $input = $el.is('input') ? $el : $el.find('input[type="radio"]'),
                    paymentType = $input.val();

                [...$accordionBody].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.show());

                $input.attr('checked', 'checked');
                if ($el.is('a')) {
                    $input.trigger('click');
                }

                if (paymentType === 'cc-accordion') {
                    $('#collapse-payment nav > div:last-child button').addClass('hidden');
                } else {
                    $('#collapse-payment nav > div:last-child button').removeClass('hidden');
                }
            });

            $selector.off('click', '.checkout-next, .checkout-previous');
            $selector.on('click', '.checkout-next, .checkout-previous', function (e) {
                var direction = $(this).data('setu-direction'),
                    $currentPanel = $(e.target).parents('.panel-collapse'),
                    $nextPanel = $($currentPanel.data(direction)),
                    $currentHeader = $(e.target).parents('.card').find('.card-header'),
                    $nextHeader = $nextPanel.parents('.card').find('.card-header');


                $currentHeader.toggleClass('current').addClass('visited');
                $nextHeader.toggleClass('current');
                $nextHeader.removeClass('disabled');
                $nextHeader.find('a').attr('data-bs-toggle', 'collapse');
                $nextHeader.find('a').attr('data-bs-parent', 'checkout-accordion');
                $nextHeader.find('a').attr('href', '#' + $nextPanel.attr('id'));
                [...$currentPanel.get()].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.hide());
                [...$nextPanel.get()].map(collapseEl => Collapse.getOrCreateInstance(collapseEl, {toggle: false})?.show());
            });
        }
    };
}
export const checkout = Checkout();
